import axios from "../../../services/axios-config.js";

export async function updateCommissionedAgent({ data }) {
  const res = await axios.post("/commissioned/update", { data });
  return res?.data;
}
